import { Disclosure } from '@headlessui/react';
// import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import { Bars3CenterLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useSession } from 'next-auth/react';

import { ProfileDisclosure, ProfileMenu } from './UserNav';
import useUser from '../../../lib/hooks/users';

// @ts-expect-error
import { ReactComponent as Logo } from '../../../assets/logo.svg';

const navigation = [];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function NavBar() {
  const { status } = useSession();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { user, isLoading } = useUser();

  const isLoggedIn = status === 'authenticated';

  return (
    <Disclosure as="nav" className="flex-shrink-0 bg-rum-600">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              {/* Logo section */}
              <div className="flex items-center px-2 lg:px-0 xl:w-64">
                <div className="flex-shrink-0">
                  <Logo className="h-8 w-auto text-rum-200" />
                </div>
              </div>

              {/* Search section */}
              {/* {isLoggedIn && (
                <div className="flex-1 flex justify-center lg:justify-end">
                  <div className="w-full px-2 lg:px-6">
                    <label htmlFor="search" className="sr-only">
                      Search campaigns
                    </label>
                    <div className="relative text-rum-200 focus-within:text-gray-400">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <MagnifyingGlassIcon
                          className="h-5 w-5"
                          aria-hidden="true"

                          />
                      </div>
                      <input
                        id="search"
                        name="search"
                        className="block w-full pl-10 pr-3 py-2 border border-transparent rounded-md leading-5 bg-rum-400 bg-opacity-25 text-rum-100 placeholder-rum-200 focus:outline-none focus:bg-white focus:ring-0 focus:placeholder-gray-400 focus:text-gray-900 sm:text-sm"
                        placeholder="Search campaigns"
                        type="search"
                      />
                    </div>
                  </div>
                </div>
              )} */}

              <div className="flex lg:hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="bg-rum-600 inline-flex items-center justify-center p-2 rounded-md text-rum-400 hover:text-white hover:bg-rum-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-rum-600 focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3CenterLeftIcon
                      className="block h-6 w-6"
                      aria-hidden="true"
                    />
                  )}
                </Disclosure.Button>
              </div>
              {/* Links section */}
              <div className="hidden lg:block lg:w-80">
                <div className="flex items-center justify-end">
                  {isLoggedIn && (
                    <div className="flex">
                      {navigation.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          className="px-3 py-2 rounded-md text-sm font-medium text-rum-200 hover:text-white"
                          aria-current={item.current ? 'page' : undefined}
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  )}
                  {/* Profile dropdown */}
                  <ProfileMenu status={status} user={user} />
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="lg:hidden">
            {isLoggedIn && (
              <div className="px-2 pt-2 pb-3 space-y-1">
                {navigation.map((item) => (
                  <Disclosure.Button
                    key={item.name}
                    as="a"
                    href={item.href}
                    className={classNames(
                      item.current
                        ? 'text-white bg-rum-800'
                        : 'text-rum-200 hover:text-rum-100 hover:bg-rum-600',
                      'block px-3 py-2 rounded-md text-base font-medium',
                    )}
                    aria-current={item.current ? 'page' : undefined}
                  >
                    {item.name}
                  </Disclosure.Button>
                ))}
              </div>
            )}
            <div className="pt-4 pb-3 border-t border-rum-800">
              <div className="px-2 space-y-1">
                <ProfileDisclosure status={status} />
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

export default NavBar;
